import React from 'react'

import { Flex, Link, styled, Text, UserAvatar } from '@driftt/dds'

import ActivityActions, { ActionType } from 'components/ActivityActions'
import { ActivityEndUser, CompanyData } from 'modules/accountActivity/domain'

const ContactRow = styled(Flex, {
  padding: '8px 0px',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid $gray3'
  }
})

interface ActionableContactListItemProps {
  endUserData: ActivityEndUser
  userPresence: 'available' | 'away'
  companyData?: CompanyData
  onClick: () => void
  actionTypes: ActionType[]
}

export const ActionableContactListItem = ({
  endUserData,
  userPresence,
  companyData,
  onClick,
  actionTypes
}: ActionableContactListItemProps) => {
  return (
    <ContactRow fullWidth direction="row" justifyContent="space-between" alignItems="center">
      <Flex alignItems="center">
        <UserAvatar
          imageUrl={endUserData.avatarUrl}
          name={endUserData.name}
          size="small"
          status={userPresence}
        />
        <Link variant="inline" onClick={onClick}>
          {endUserData.name || endUserData.email || 'Site Visitor'}
        </Link>
        <Text variant="subtitle2">{endUserData.role || ''}</Text>
      </Flex>
      <ActivityActions
        endUserData={endUserData}
        companyData={companyData}
        actionTypes={actionTypes}
      />
    </ContactRow>
  )
}
